module.exports = __webpack_public_path__ + "img/lori.8073ee61.png";